import React from 'react';
import CountUp from 'react-countup';
import { Card, CardBody, Row, Col, CardHeader } from 'reactstrap';
import CardWithoutData from '../../Common/CardWithoutData';
import OCountUp from '../../OElements/OCountUp';

const SimpleAccountCard = ({ label, prefix, suffix, decimals, counter, percentage, caption }) => {


    const counter2 = 12345.678; // Ejemplo de número final

    return (
        <Card className='card-height-100'>
            <CardBody className='p-2'>
                <Row>
                    <Col>
                        <p className='text-uppercase m-0 fw-semibold text-muted'>
                            {label}
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className='m-0 text-left fw-semibold'>
                            <span className="counter-value m-0 text-left fw-semibold">
                                <OCountUp
                                    start={0}
                                    end={counter}
                                    prefix={prefix}
                                    suffix={suffix}
                                    decimals={2}
                                    duration={3}
                                />
                            </span>
                        </h2>
                        <p className='m-0 text-truncate' style={{ padding: '0px 0px 10px' }}>
                            {percentage <= 0 ? (
                                <span className="badge bg-success-subtle text-success">
                                    <i className="ri-arrow-down-line"></i> {percentage}%
                                </span>
                            ) : (
                                <span className="badge bg-danger-subtle text-danger">
                                    <i className="ri-arrow-up-line"></i> {percentage}%
                                </span>
                            )}
                            <span className='text-muted fs-12'> {caption}</span>
                        </p>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );


    return <CardWithoutData title={title} />;

};

export default SimpleAccountCard;
